<app-sqp-ui-styles></app-sqp-ui-styles>
<app-sqp-ui-icons></app-sqp-ui-icons>
<router-outlet></router-outlet>
